/* eslint-disable sonarjs/no-use-of-empty-return-value */
import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';
import QRCode from 'react-qr-code';
import RipplrLogo from 'assets/ripplr-logo.svg';
import { Text, Flex, Image, Box } from 'atoms';

const QrMainBox = styled(Flex)`
	padding: 16px;
	flex-direction: column;
	align-items: center;
	gap: 5rem;
`;

const QrTopBox = styled(Flex)`
	padding: 16px;
	justify-content: space-between;
	gap: 20rem;
`;
const QrMiddleBox = styled(Flex)`
	font-size: 16px;
	gap: 0.5rem;
	flex-direction: column;
	align-items: center;
`;

const PrintQrBox = styled(QRCode)`
	padding: 3rem;
	border-radius: 5px;
	border: 2px solid #ababab;
`;

export default function PrintQr({ projectLocCode }) {
	return (
		<Box>
			<Box
				// style={{ visibility: 'hidden' }}
				id="project_qr_code"
			>
				<QrMainBox>
					<QrTopBox>
						<Box>
							<Image src={RipplrLogo} alt="Ripplr Cartoon" />
						</Box>
						<Box>{/* <Image src={RipplrLogo} alt="Ripplr Cartoon" /> */}</Box>
					</QrTopBox>
					<QrMiddleBox>
						<PrintQrBox id="qr-gen" value={projectLocCode} size={300} />
						<Text>
							Use the <span style={{ fontWeight: 600 }}>Ripplr App</span> to scan this
						</Text>
					</QrMiddleBox>
					<Box>
						<Text>
							1. Open <span style={{ fontWeight: 600 }}> “Play Store”</span> App
						</Text>
						<Text>
							2. Search for <span style={{ fontWeight: 600 }}>“Ripplr”</span>
						</Text>
						<Text>
							3. Install the app & <span style={{ fontWeight: 600 }}>Scan</span>
						</Text>
					</Box>
				</QrMainBox>
			</Box>
		</Box>
	);
}

PrintQr.propTypes = {
	projectLocCode: PropTypes.any,
};
